// ── COUNTDOWN — manejado por announcement-bar.liquid ──

// ── LIVE NOTIFICATIONS — desactivadas ──

// ── STOCK COUNTER ──
var stock={m:47,d:38};
function dropStock(){
  if(Math.random()>.45){
    stock.m=Math.max(stock.m-1,4);
    stock.d=Math.max(stock.d-1,3);
  }
  document.querySelectorAll('.stock-mobility').forEach(function(e){e.textContent=stock.m;});
  document.querySelectorAll('.stock-digestive').forEach(function(e){e.textContent=stock.d;});
  var h=document.getElementById('stock-hero');
  if(h) h.textContent=stock.m;
  var pct=Math.round(stock.m/150*100);
  var b=document.getElementById('stock-bar-hero');
  if(b) b.style.width=pct+'%';
}
setInterval(dropStock,50000);

// ── BUYERS COUNTER ──
var buyers=12;
function fluctuate(){
  buyers+=Math.floor(Math.random()*3)-1;
  buyers=Math.max(8,Math.min(buyers,26));
  var e=document.getElementById('buyers-now');
  if(e) e.textContent=buyers;
}
setInterval(fluctuate,9000);

// ── FAQ ──
function toggleFaq(el){
  var item=el.parentElement;
  var open=item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(function(i){i.classList.remove('open');});
  if(!open) item.classList.add('open');
}

// ── SMOOTH SCROLL ── (event delegation — funciona con elementos fixed como announcement bar)
document.addEventListener('click',function(e){
  var a=e.target.closest('a[href^="#"]');
  if(!a) return;
  var href=a.getAttribute('href');
  if(!href||href==='#') return;
  var target=document.querySelector(href);
  if(!target) return;
  e.preventDefault();
  // Offset = announcement bar (46px) + nav (60px) + margen extra (8px)
  var offset=114;
  var top=target.getBoundingClientRect().top+window.scrollY-offset;
  window.scrollTo({top:Math.max(0,top),behavior:'smooth'});
});

// ── SHOPIFY FIXES ──
dropStock(); // initial stock display

// ── CART ──
function openCart(){
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow='hidden';
  fetchAndRenderCart();
}
function closeCart(){
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.body.style.overflow='';
}
function fetchAndRenderCart(){
  fetch('/cart.js',{headers:{'Content-Type':'application/json'}})
  .then(function(r){return r.json();})
  .then(function(cart){renderCart(cart);})
  .catch(function(e){console.error('Cart fetch error:',e);});
}
// IDs of the 3-pack bundle variants (Mobility 3 bolsas + Digestive 3 bolsas)
var ZV_BUNDLE3_IDS=[53309154984301,53309155049837];

function countCartBags(cart){
  var total=0;
  cart.items.forEach(function(item){
    if(ZV_BUNDLE3_IDS.indexOf(item.variant_id)>=0){
      total+=3*item.quantity;
    } else {
      var vt=(item.variant_title||'').toLowerCase();
      var bags=vt.indexOf('3 bolsa')>=0?3:vt.indexOf('2 bolsa')>=0?2:1;
      total+=bags*item.quantity;
    }
  });
  return total;
}

function renderOfferBar(totalBags, discountApplied){
  var el=document.getElementById('cart-offer-bar');
  if(!el)return;
  if(totalBags<=0){el.innerHTML='';return;}
  var pct=Math.min(100,Math.round((totalBags/3)*100));
  if(totalBags>=3){
    var discountNote=discountApplied
      ?'<div class="cart-ob-discount-note">✅ Descuento aplicado automáticamente</div>'
      :'<div class="cart-ob-discount-note">🔄 Actualiza el carrito para ver el precio final</div>';
    el.innerHTML=
      '<div class="cart-ob-wrap">'+
        '<div class="cart-ob-inner cart-ob-inner--win">'+
          '<div class="cart-ob-txt cart-ob-txt--win">🎁 ¡1 bolsa completamente GRATIS incluida en tu kit!</div>'+
          '<div class="cart-ob-track"><div class="cart-ob-fill cart-ob-fill--win" style="width:100%"></div></div>'+
          discountNote+
        '</div>'+
      '</div>';
  } else {
    var left=3-totalBags;
    var plural=left===1?'bolsa':'bolsas';
    el.innerHTML=
      '<div class="cart-ob-wrap">'+
        '<div class="cart-ob-inner cart-ob-inner--progress">'+
          '<div class="cart-ob-txt cart-ob-txt--progress">🎁 Agrega <strong>'+left+' '+plural+' más</strong> y llévate 1 GRATIS</div>'+
          '<div class="cart-ob-track"><div class="cart-ob-fill cart-ob-fill--progress" style="width:'+pct+'%"></div></div>'+
        '</div>'+
      '</div>';
  }
}

function renderCart(cart){
  var wrap=document.getElementById('cart-items-wrap');
  var footer=document.getElementById('cart-footer');
  var badge=document.getElementById('cart-count');
  if(badge){
    badge.textContent=cart.item_count;
    badge.classList.toggle('hidden',cart.item_count===0);
  }
  if(!cart.item_count){
    wrap.innerHTML='<div class="cart-empty"><div class="cart-empty-icon">🛒</div><p>Tu carrito está vacío</p><span class="cart-empty-link" onclick="closeCart()">← Seguir comprando</span></div>';
    footer.style.display='none';
    renderOfferBar(0);
    return;
  }
  footer.style.display='block';

  // Count total bags and detect if BXGY discount is applied
  var totalBags=countCartBags(cart);
  var discountApplied=cart.cart_level_discount_applications&&cart.cart_level_discount_applications.length>0;
  // Also check item-level discount allocations
  if(!discountApplied){
    discountApplied=cart.items.some(function(item){
      return item.discount_allocations&&item.discount_allocations.length>0;
    });
  }
  renderOfferBar(totalBags, discountApplied);

  var html='';
  var totalSaved=0;
  cart.items.forEach(function(item,index){
    var finalLine=item.final_line_price/100;
    var origLine=item.original_line_price/100;
    var itemSaved=origLine-finalLine;
    // También considera compare_at_price como ahorro si no hay descuento activo
    var compareAtLine=item.compare_at_price?item.compare_at_price*item.quantity/100:0;
    var effectiveSaved=itemSaved>0?itemSaved:(compareAtLine>finalLine?compareAtLine-finalLine:0);
    totalSaved+=effectiveSaved;
    var finalPrice='$'+finalLine.toLocaleString('es-MX',{minimumFractionDigits:0,maximumFractionDigits:0});
    var emoji=item.product_title.indexOf('Mobility')>=0?'🦴':'🌿';
    var imgHtml=item.image
      ?'<img src="'+item.image+'" class="cart-item-img" alt="'+item.product_title+'" loading="lazy">'
      :'<div class="cart-item-thumb">'+emoji+'</div>';
    // Show "🎁 Incluye 1 GRATIS" badge on 3-pack items
    var isBundle3=ZV_BUNDLE3_IDS.indexOf(item.variant_id)>=0||((item.variant_title||'').toLowerCase().indexOf('3 bolsa')>=0);
    var freeTag=isBundle3?'<span class="cart-item-free-tag">🎁 Incluye 1 GRATIS</span>':'';
    var freeBreakdown=isBundle3?'<div class="cart-item-free-breakdown">2 pagas · <span class="cart-item-free-highlight">🎁 1 completamente GRATIS</span></div>':'';
    // Friendly variant label: if "1 bolsa" x2, show "2 bolsas"; if "1 bolsa" x3, show "3 bolsas"
    var variantLabel=item.variant_title||'';
    if(item.quantity>1&&variantLabel.toLowerCase()==='1 bolsa'){
      variantLabel=item.quantity+' bolsas';
    }
    // Precio unitario para mostrar "X × $Y"
    var unitPrice=item.final_price/100;
    var unitFmt='$'+unitPrice.toLocaleString('es-MX',{minimumFractionDigits:0,maximumFractionDigits:0});
    // Compare-at price (precio original tachado de Shopify)
    var compareAt=item.compare_at_price?item.compare_at_price*item.quantity/100:0;
    var hasCompare=compareAt>finalLine;
    // Ahorro real: descuento activo O compare-at price
    var displaySaved=itemSaved>0?itemSaved:(hasCompare?compareAt-finalLine:0);
    var displayOrig=itemSaved>0?origLine:(hasCompare?compareAt:0);
    // Price display
    var priceHtml;
    if(displaySaved>0){
      var origPriceFmt='$'+displayOrig.toLocaleString('es-MX',{minimumFractionDigits:0,maximumFractionDigits:0});
      var savedAmtFmt='$'+displaySaved.toLocaleString('es-MX',{minimumFractionDigits:0,maximumFractionDigits:0});
      var unitNote=item.quantity>1?'<span class="cart-item-unit-note">'+item.quantity+' × '+unitFmt+'</span>':'';
      priceHtml=
        '<div class="cart-item-price-block">'+
          unitNote+
          '<span class="cart-item-price-orig">'+origPriceFmt+'</span>'+
          '<span class="cart-item-price">'+finalPrice+' MXN</span>'+
          '<span class="cart-item-price-save">Ahorras '+savedAmtFmt+'</span>'+
        '</div>';
    } else if(item.quantity>1){
      priceHtml=
        '<div class="cart-item-price-block">'+
          '<span class="cart-item-unit-note">'+item.quantity+' × '+unitFmt+'</span>'+
          '<span class="cart-item-price">'+finalPrice+' MXN</span>'+
        '</div>';
    } else {
      priceHtml='<span class="cart-item-price">'+finalPrice+' MXN</span>';
    }
    html+='<div class="cart-item">'+
      imgHtml+
      '<div class="cart-item-info">'+
        '<div class="cart-item-title">'+item.product_title+'</div>'+
        '<div class="cart-item-variant-row">'+
          '<span class="cart-item-variant">'+variantLabel+'</span>'+
          freeTag+
        '</div>'+
        freeBreakdown+
        '<div class="cart-item-row">'+
          priceHtml+
          '<div class="cart-qty">'+
            '<button class="cart-qty-btn" onclick="changeQty('+index+',-1)" aria-label="Menos">−</button>'+
            '<span class="cart-qty-num">'+item.quantity+'</span>'+
            '<button class="cart-qty-btn" onclick="changeQty('+index+',1)" aria-label="Más">+</button>'+
          '</div>'+
        '</div>'+
      '</div>'+
    '</div>';
  });
  wrap.innerHTML=html;
  var total='$'+(cart.total_price/100).toLocaleString('es-MX',{minimumFractionDigits:0,maximumFractionDigits:0});
  document.getElementById('cart-total-amount').innerHTML=total+'<span class="cart-subtotal-currency"> MXN</span>';
  var savings=document.getElementById('cart-savings-line');
  if(savings){
    // totalSaved ya incluye compare_at y descuentos activos por ítem
    // También verificar descuentos a nivel carrito (BXGY automático)
    var cartLevelSaved=0;
    if(cart.cart_level_discount_applications){
      cart.cart_level_discount_applications.forEach(function(d){
        if(d.value_type==='fixed_amount') cartLevelSaved+=parseFloat(d.value)||0;
        else if(d.value_type==='percentage') cartLevelSaved+=(cart.original_total_price/100)*(parseFloat(d.value)/100);
      });
    }
    var finalSaved=totalSaved+cartLevelSaved;
    if(finalSaved>0){
      var origCartTotal=(cart.total_price/100)+finalSaved;
      var origTotalFmt='$'+origCartTotal.toLocaleString('es-MX',{minimumFractionDigits:0,maximumFractionDigits:0});
      var savedFmt='$'+finalSaved.toLocaleString('es-MX',{minimumFractionDigits:0,maximumFractionDigits:0});
      savings.innerHTML=
        '<div class="cart-savings-block">'+
          '<span class="cart-savings-orig">Precio normal: <s>'+origTotalFmt+' MXN</s></span>'+
          '<span class="cart-savings-amt">🎉 Ahorras '+savedFmt+' MXN</span>'+
        '</div>';
    } else {
      savings.innerHTML='';
    }
  }
}
function goToCheckout(){
  var url='/checkout';
  try{
    // Funciona en iframe del theme editor y en la tienda normal
    if(window.top&&window.top!==window) window.top.location.href=url;
    else window.location.href=url;
  }catch(e){
    window.location.href=url;
  }
}
function changeQty(lineIndex,delta){
  // Use line number (1-based) — most reliable way to update Shopify cart
  fetch('/cart.js',{headers:{'Content-Type':'application/json'}})
  .then(function(r){return r.json();})
  .then(function(cart){
    var item=cart.items[lineIndex];
    if(!item)return Promise.reject('Item not found at index '+lineIndex);
    var newQty=Math.max(0,item.quantity+delta);
    return fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({line:lineIndex+1,quantity:newQty})
    });
  })
  .then(function(r){if(r&&r.ok)return r.json();})
  .then(function(cart){if(cart)renderCart(cart);})
  .catch(function(e){console.error('Change qty error:',e);});
}
function addToCart(variantIds,btn){
  if(btn){btn.classList.add('adding');}
  var items=variantIds.map(function(id){return{id:parseInt(id,10),quantity:1};});
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:items})
  })
  .then(function(r){
    if(!r.ok)return r.json().then(function(e){throw new Error(e.description||'Error al agregar al carrito');});
    return r.json();
  })
  .then(function(){
    if(btn)btn.classList.remove('adding');
    openCart();
  })
  .catch(function(e){
    console.error('Add to cart error:',e);
    if(btn)btn.classList.remove('adding');
    alert(e.message||'Hubo un error. Por favor intenta de nuevo.');
  });
}

// ── PRODUCT DETAILS ACCORDION (mobile) ──
function toggleDetails(id, btn) {
  var el = document.getElementById(id);
  if(!el) return;
  var open = el.classList.toggle('open');
  btn.setAttribute('aria-expanded', String(open));
}

// ── PACK SELECTION STATE ──
var mixActive = {mobility: false, digestive: false};
var selectedPack = {mobility: 2, digestive: 2};

// Config: text/sub/ids/colors per product & pack
var PACK_CFG = {
  mobility: {
    1:      { ids:['53267565805933'],                       text:'🦴 Agregar 1 bolsa — $499 MXN →',      sub:'30 masticables · Envío gratis incluido',              bg:'#1b4332' },
    2:      { ids:['53309154951533'],                       text:'🦴 Agregar 2 bolsas — $989 MXN →',     sub:'Envío gratis · Precio presale',                      bg:'#2d6a4f' },
    '2mix': { ids:['53267565805933','53267565838701'],      text:'🦴 Agregar MIX — $949 MXN →',          sub:'1 Mobility + 1 Digestive · Prueba las dos fórmulas', bg:'#2d6a4f' },
    3:      { ids:['53309154984301'],                       text:'🦴 Agregar 3 bolsas — $1,470 MXN →',   sub:'Máximo ahorro — ahorras $327 vs precio original',     bg:'#c96a1a' }
  },
  digestive: {
    1:      { ids:['53267565838701'],                       text:'🌿 Agregar 1 bolsa — $450 MXN →',      sub:'30 masticables · Envío gratis incluido',              bg:'#c96a1a' },
    2:      { ids:['53309155017069'],                       text:'🌿 Agregar 2 bolsas — $829 MXN →',     sub:'Envío gratis · Precio presale',                      bg:'#c96a1a' },
    '2mix': { ids:['53267565838701','53267565805933'],      text:'🌿 Agregar MIX — $949 MXN →',          sub:'1 Digestive + 1 Mobility · Prueba las dos fórmulas', bg:'#c96a1a' },
    3:      { ids:['53309155049837'],                       text:'🌿 Agregar 3 bolsas — $949 MXN →',     sub:'Máximo ahorro — ahorras $401 vs precio original',     bg:'#a85614' }
  }
};

function updateProductCTA(type) {
  var pack = selectedPack[type];
  var key  = (pack === 2 && mixActive[type]) ? '2mix' : pack;
  var cfg  = PACK_CFG[type][key];
  if(!cfg) return;

  var textEl = document.getElementById('pdcta-text-' + type);
  var subEl  = document.getElementById('pdcta-sub-'  + type);
  var btn    = document.getElementById('product-cta-' + type);
  if(!btn) return;

  // Animate transition
  btn.style.opacity = '0.75';
  btn.style.transform = 'scale(0.98)';
  setTimeout(function(){
    if(textEl) textEl.textContent = cfg.text;
    if(subEl)  subEl.textContent  = cfg.sub;
    btn.style.background = cfg.bg;
    btn.style.opacity = '1';
    btn.style.transform = 'scale(1)';
  }, 100);
}

function selectProductPack(type, pack, e) {
  if(e) { e.preventDefault(); e.stopPropagation(); }
  selectedPack[type] = pack;

  // Update visual selected state on pack options
  document.querySelectorAll('.pack-selectable[data-type="'+type+'"]').forEach(function(el){
    el.classList.toggle('pack-selected', parseInt(el.getAttribute('data-pack')) === pack);
  });

  updateProductCTA(type);
}

// ── MIX TOGGLE ──
function toggleMix(e, type) {
  e.stopPropagation();
  mixActive[type] = !mixActive[type];
  var sw = document.getElementById(type + '-mix-switch');
  if(sw) sw.classList.toggle('active', mixActive[type]);
  var nameEl  = document.getElementById(type + '-pack2-name');
  var unitsEl = document.getElementById(type + '-pack2-units');
  var priceEl = document.getElementById(type + '-pack2-price');
  var oldEl   = document.getElementById(type + '-pack2-old');
  if(mixActive[type]) {
    if(nameEl)  nameEl.textContent  = (type === 'mobility' ? '1 Mobility + 1 Digestive' : '1 Digestive + 1 Mobility');
    if(unitsEl) unitsEl.textContent = '60 masticables · Prueba ambas fórmulas · Envío gratis';
    if(priceEl) priceEl.textContent = '$1,098';
    if(oldEl)   oldEl.textContent   = '$1,280';
  } else {
    var defaults = {
      mobility:  {name:'2 bolsas — Resultado real', units:'60 masticables · 2 meses · Envío gratis', price:'$989', old:'$1,198'},
      digestive: {name:'2 bolsas — Resultado real', units:'60 masticables · 2 meses · Envío gratis', price:'$829', old:'$998'}
    };
    var d = defaults[type];
    if(nameEl)  nameEl.textContent  = d.name;
    if(unitsEl) unitsEl.textContent = d.units;
    if(priceEl) priceEl.textContent = d.price;
    if(oldEl)   oldEl.textContent   = d.old;
  }
  // Also re-select pack 2 to refresh CTA
  if(selectedPack[type] === 2) updateProductCTA(type);
}

// Wire up all cart buttons on DOMContentLoaded
document.addEventListener('DOMContentLoaded',function(){
  // ── Dynamic product CTA buttons ──
  document.querySelectorAll('.product-dynamic-cta').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var type = btn.getAttribute('data-type');
      var pack = selectedPack[type];
      var key  = (pack === 2 && mixActive[type]) ? '2mix' : pack;
      var cfg  = PACK_CFG[type][key];
      if(cfg) addToCart(cfg.ids, btn);
    });
  });

  // Mix options (multiple variants) — legacy
  document.querySelectorAll('.mix-option[data-variant-ids]').forEach(function(el){
    el.addEventListener('click',function(e){
      e.preventDefault();
      addToCart(this.dataset.variantIds.split(','),null);
    });
  });
  // Buy buttons (outside product cards) — respect mixActive
  document.querySelectorAll('.btn-buy[data-variant-id]').forEach(function(el){
    el.addEventListener('click',function(e){
      e.preventDefault();
      var type   = this.getAttribute('data-type');
      var mixIds = this.getAttribute('data-mix-ids');
      var ids;
      if(type && mixIds && mixActive[type]) {
        ids = mixIds.split(',');
      } else {
        ids = [this.getAttribute('data-variant-id')];
      }
      addToCart(ids, this);
    });
  });
  // Final CTA add-to-cart button
  document.querySelectorAll('.btn-add-to-cart[data-variant-id]').forEach(function(el){
    el.addEventListener('click',function(e){
      e.preventDefault();
      addToCart([this.dataset.variantId],this);
    });
  });
  // Close drawer on Escape key
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape')closeCart();
  });
  // Sync badge on page load
  fetch('/cart.js',{headers:{'Content-Type':'application/json'}})
  .then(function(r){return r.json();})
  .then(function(cart){
    var badge=document.getElementById('cart-count');
    if(badge&&cart.item_count>0){
      badge.textContent=cart.item_count;
      badge.classList.remove('hidden');
    }
  });
});
